import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPeople = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 37,
	viewBox: "0 0 38 37",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M29.5508 12.1406C29.3391 15.0797 27.1588 17.3438 24.7813 17.3438C22.4037 17.3438 20.2199 15.0804 20.0117 12.1406C19.7949 9.08307 21.9174 6.9375 24.7813 6.9375C27.6452 6.9375 29.7676 9.13871 29.5508 12.1406Z",
			stroke: "currentColor",
			strokeWidth: 2.375,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.7812 21.9688C20.0717 21.9688 15.5428 24.308 14.4082 28.8636C14.2579 29.4663 14.6359 30.0625 15.2552 30.0625H34.308C34.9273 30.0625 35.3031 29.4663 35.155 28.8636C34.0204 24.235 29.4915 21.9688 24.7812 21.9688Z",
			stroke: "currentColor",
			strokeWidth: 2.375,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9531 13.4371C14.784 15.7843 13.0222 17.6328 11.123 17.6328C9.22391 17.6328 7.45918 15.785 7.29297 13.4371C7.12025 10.9952 8.83512 9.25 11.123 9.25C13.411 9.25 15.1258 11.04 14.9531 13.4371Z",
			stroke: "currentColor",
			strokeWidth: 2.375,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3867 22.1133C14.0823 21.5157 12.6457 21.2859 11.123 21.2859C7.36521 21.2859 3.7447 23.1539 2.83776 26.7925C2.71853 27.2738 3.0206 27.75 3.51489 27.75H11.6289",
			stroke: "currentColor",
			strokeWidth: 2.375,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		})
	]
});
export default SvgPeople;
